import { Button, Image } from "@chakra-ui/react";
import { logEvent } from "firebase/analytics";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { analytics } from "../firebase";

import { useAtom } from "jotai";
import { windowSizeState } from "../jotai";
import deer from "./nz country.png";

export const Home = () => {
  const [size] = useAtom(windowSizeState);
  //const [isSound, setIsSound] = useRecoilState(soundState);
  const nav = useNavigate();
  useEffect(() => {
    logEvent(analytics, "page_view", { page_title: "Home" });
  }, []);

  return (
    <>
      <Helmet>
        <title>NZ COUNTRY</title>
        <meta
          name="description"
          content="NZ COUNTRY - Premium trophy hunting in New Zealand. Guided hunting for trophy deer, fallow deer, goat, thar, and arapawa rams."
        />
        <meta
          name="keywords"
          content="hunting guides, New Zealand hunting, red deer hunting, tahr hunting, chamois hunting, guided hunts, New Zealand wilderness, hunting tours, goat hunting, fallow deer hunting, Arapawa rams hunting, accommodation"
        />
        <meta name="author" content="NZ COUNTRY - Hunting Guides New Zealand" />
        <meta name="theme-color" content="#000000" />
        <meta
          property="og:title"
          content="NZ COUNTRY - Hunting Guides New Zealand"
        />

        <meta
          property="og:description"
          content="NZ COUNTRY premium trophy hunting and accommodation in New Zealand. Guided hunting for trophy deer, fallow deer, goat, thar, and arapawa rams."
        />
        <meta property="og:url" content="https://www.nzcountry.guide" />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:card"
          content="Premium trophy hunting in New Zealand"
        />
        <meta
          name="twitter:title"
          content="NZ COUNTRY - Hunting Guides New Zealand - Experience the Wild"
        />
        <meta
          name="twitter:description"
          content="Discover unparalleled hunting adventures in New Zealand' South Island with expert guides and stunning wilderness settings."
        />
        <meta
          name="twitter:image"
          content="https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/images%2FSocial%20Media-%20Twitter.jpg?alt=media"
        />
      </Helmet>
      <div style={{ height: "100vh", overflowY: "hidden" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Image
                src={deer}
                width={size.width / 4}
                style={{
                  width: size.width < 700 ? "150px" : `${size.width / 4}px`,
                }}
                loading="eager"
                onClick={() => {
                  logEvent(analytics, "select_item", {
                    item_list_name: "home to outreach",
                  });
                  nav("/trophy-hunting-new-zealand");
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column", //width < 930 ? "column" : "row"
                  alignItems: "center",
                  width: "90vw",
                  maxWidth: "500px",
                  justifyContent: "space-evenly",
                }}
              >
                <Button
                  variant="link"
                  size="lg"
                  color={"#EA9101"}
                  onClick={() => {
                    logEvent(analytics, "select_item", {
                      item_list_name: "home to trophy hunting",
                    });
                    nav("/trophy-hunting-new-zealand");
                  }}
                  fontFamily={"anton"}
                  fontSize={size.width < 800 ? "1.3rem" : "2rem"}
                  letterSpacing={1.5}
                >
                  Trophy Hunting
                </Button>
                <Button
                  variant="link"
                  size="lg"
                  color={"#EA9101"} //{"#B0B0A0"}
                  onClick={() => {
                    logEvent(analytics, "select_item", {
                      item_list_name: "home to outreach",
                    });
                    nav("/outreach");
                  }}
                  fontFamily={"anton"}
                  fontSize={size.width < 800 ? "1.3rem" : "2rem"}
                  letterSpacing={1.5}
                >
                  Community Outreach
                </Button>
                <Button
                  variant="link"
                  size="lg"
                  color={"#EA9101"}
                  onClick={() => {
                    logEvent(analytics, "select_item", {
                      item_list_name: "home to packages",
                    });
                    nav("/packages");
                  }}
                  fontFamily={"anton"}
                  fontSize={size.width < 800 ? "1.3rem" : "2rem"}
                  letterSpacing={1.5}
                >
                  Pricing
                </Button>
                <Button
                  variant="link"
                  size="lg"
                  color={"#EA9101"}
                  fontSize={size.width < 800 ? "1.3rem" : "2rem"}
                  onClick={() => {
                    logEvent(analytics, "select_item", {
                      item_list_name: "home to about",
                    });
                    nav("/about");
                  }}
                  fontFamily={"anton"}
                  letterSpacing={1.5}
                >
                  About
                </Button>
                <Button
                  variant="link"
                  size="lg"
                  color={"#EA9101"} //{"#B0B0A0"}
                  onClick={() => {
                    logEvent(analytics, "select_item", {
                      item_list_name: "home to inquire",
                    });
                    nav("/inquire");
                  }}
                  fontFamily={"anton"}
                  fontSize={size.width < 800 ? "1.3rem" : "2rem"}
                  letterSpacing={1.5}
                >
                  Contact
                </Button>
              </div>
              <div style={{ padding: "1rem" }}>
                {/* <Button
                variant="link"
                size="sm"
                color={"#EA9101"}
                onClick={() => (isSound ? setIsSound(false) : setIsSound(true))}
              >
                {isSound ? "Turn sound OFF" : "Turn sound ON"}
              </Button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
